import Vue from "vue";
// 引入组件
import OrderPay from "@/components/orderPay.vue";

// 创建构造器
const OrderPayBox = Vue.extend(OrderPay);

OrderPay.install = function (data) {
    // data：调用组件时传入参数【操作组件data中数据】，见下图
    // 创建组件对象，并挂载
    let instance = new OrderPayBox({
        data
    }).$mount(); // $mount(document.createElement('div') 【也可以挂载到某个元素上】

    // 将组件添加到dom中
    document.body.appendChild(instance.$el);
    // 调用方法或操作属性
    Vue.nextTick(() => {
        // instance.open();
        instance.visible = true;
    });
};

export default OrderPay;